import { render, staticRenderFns } from "./TourCalendars.vue?vue&type=template&id=0161d346&"
import script from "./TourCalendars.vue?vue&type=script&lang=js&"
export * from "./TourCalendars.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports